import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

const UserRoleText = ({role}) => (
    messages.userRoles[role] ?
        <FormattedMessage {...messages.userRoles[role]} /> :
        <span>{role}</span>
);

export default UserRoleText;
